var React = require('react');

function SquareFull (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M-1 0v512h512V0zm432 417.33A14.67 14.67 0 0 1 416.33 432H93.67A14.67 14.67 0 0 1 79 417.33V94.67A14.67 14.67 0 0 1 93.67 80h322.66A14.67 14.67 0 0 1 431 94.67z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M431 417.33A14.67 14.67 0 0 1 416.33 432H93.67A14.67 14.67 0 0 1 79 417.33V94.67A14.67 14.67 0 0 1 93.67 80h322.66A14.67 14.67 0 0 1 431 94.67z","className":"fa-primary","key":2})]);
}

SquareFull.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = SquareFull;

SquareFull.default = SquareFull;
